var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.834 13.7834V36.4838C43.834 37.5242 43.4635 38.4149 42.7226 39.1558C41.9817 39.8967 41.091 40.2672 40.0506 40.2672H9.7834C8.74296 40.2672 7.85229 39.8967 7.11137 39.1558C6.37046 38.4149 6 37.5242 6 36.4838V13.7834C6 12.743 6.37046 11.8523 7.11137 11.1114C7.85229 10.3705 8.74296 10 9.7834 10H40.0506C41.091 10 41.9817 10.3705 42.7226 11.1114C43.4635 11.8523 43.834 12.743 43.834 13.7834ZM9.7834 17.5668H40.0506V14.7834C40.0506 14.2311 39.6029 13.7834 39.0506 13.7834H10.7834C10.2311 13.7834 9.7834 14.2311 9.7834 14.7834V17.5668ZM9.7834 25.1336V35.4838C9.7834 36.0361 10.2311 36.4838 10.7834 36.4838H39.0506C39.6029 36.4838 40.0506 36.0361 40.0506 35.4838V25.1336H9.7834Z",
    fill: "#55595F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.bb7c1c5694a5cb4f9569ff0d01770050.svg";
export { ForwardRef as ReactComponent };